<template>
  <div>
    <h1 class="text-center p-3 m-3">Oops! 404 Error</h1>
    <div class="bc text-center p-3">
      <h3>
        Page Not Found. Go back to
        <router-link :to="{ name: 'landing' }">Home</router-link>
      </h3>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bc {
  margin-bottom: 250px;
}
</style>
